import { handleError } from '../../../utils/handleError';
import { deleteBudget, getBudget, getBudgetById } from './model';

export const deleteBudgetController = async (budgetId: string) => {
  try {
    const res = await deleteBudget(budgetId);
    return res;
  } catch (error) {
    handleError(error);
  }
};
export const getBudgetController = async (query = '') => {
  try {
    const res = await getBudget(query);
    return res;
  } catch (error) {
    handleError(error);
  }
};

export const getBudgetByIdController = async (id: string) => {
  try {
    const res = await getBudgetById(id);
    return res;
  } catch (error) {
    handleError(error);
  }
};
